export default '*';